export default __webpack_public_path__ + "static/25-fb67aedd6bf750bc918f9b3b11abb738.png";